<app-survey-details-navigation></app-survey-details-navigation>
